import axios from "axios";
import { wmSign, wmAes, wm_aes_for_web } from "../../apiFunc/encrypt";
import { decrypt } from "../../apiFunc/decrypt";
import { EncryptRelay } from "../EncryptRelay/EncryptRelay";
import { GetTimeStamp } from "../../apiFunc/getDate";

const appURL = `${process.env.REACT_APP_APP_URL}/api`;
const oauthURL = `${process.env.REACT_APP_OAUTH_URL}/api`;
const appId = process.env.REACT_APP_ID;
const deviceUuid = process.env.REACT_APP_DEVICE_UUID;
const apiKey = process.env.REACT_APP_API_KEY;

const baseHeader = {
  "Content-Type": "application/json",
  "Accept-Language": "zh-TW",
  "app-id": appId,
  "device-uuid": deviceUuid,
};

/**mmrm api */
async function getBrand(datatest) {
  const body = {
    timestamp: GetTimeStamp(),
  };
  const sign = wmSign(body);
  const data = {
    sign: sign,
  };
  const response = await axios.post(`${appURL}/brand/search_brand`, data, {
    headers: baseHeader,
  });
  return response.data;
}

async function searchStore(datatest) {
  const body = {
    request_parameter: {
      brand_ids: datatest.brand_ids,
      city: datatest.city,
      district: datatest.districts,
    },
    timestamp: GetTimeStamp(),
  };
  const sign = wmSign(body);
  const data = {
    sign: sign,
  };
  const response = await axios.post(`${appURL}/store/search_store`, data, {
    headers: baseHeader,
  });
  return response.data;
}

async function fetchStoreInfo(datatest) {
  const body = {
    request_parameter: {
      store_ids: datatest.store_ids,
      query_info: "summary",
    },
    timestamp: GetTimeStamp(),
  };
  const sign = wmSign(body);
  const data = {
    sign: sign,
  };
  const response = await axios.post(`${appURL}/store/store_information`, data, {
    headers: baseHeader,
  });
  return response.data;
}

async function getRecommendStore({ city, districts }) {
  const brandResp = await getBrand();
  const storeResp = await searchStore({
    brand_ids: brandResp.results.brand_ids,
    city,
    districts,
  });
  const storeInfoResp = await fetchStoreInfo(storeResp.results);
  if (storeInfoResp) {
    return storeInfoResp.results.store_information;
  }
  return null;
}

export { getBrand, searchStore, fetchStoreInfo, getRecommendStore };
